import { render } from "./Initiative.vue?vue&type=template&id=225c4305"
import script from "./Initiative.vue?vue&type=script&setup=true&lang=js"
export * from "./Initiative.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Planning/Initiative.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "225c4305"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('225c4305', __exports__)) {
    api.reload('225c4305', __exports__)
  }
  
  module.hot.accept("./Initiative.vue?vue&type=template&id=225c4305", () => {
    api.rerender('225c4305', render)
  })

}


export default __exports__